var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"title":'Edit Bed'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',[_c('Form',{attrs:{"form":_vm.form,"route":'beds/'+ _vm.form.id}})],1)]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }